import axiosClient from "../axios/axiosClient";

export function getSuperAdmins() {
  return axiosClient.get("/users");
}

export function getSuperAdmin(superAdminID) {
  return axiosClient.get(`/users/${superAdminID}`);
}

export const createSuperAdmin = (data) => {
  return axiosClient.post("/users", data);
};

export const updateSuperAdmin = (superAdminID, data) => {
  return axiosClient.put(`/users/${superAdminID}`, data);
};

export function deleteSuperAdmin(superAdminID) {
  return axiosClient.delete(`/users/${superAdminID}`);
}

export function deactivateSuperAdmin(superAdminID) {
  return axiosClient.put(`/user/${superAdminID}/deactivate`);
}

export function activateSuperAdmin(superAdminID) {
  return axiosClient.put(`/user/${superAdminID}/activate`);
}

export const resetAdminPassword = (superAdminID, data) => {
  return axiosClient.patch(
    `/reset-super-admin-password/user/${superAdminID}`,
    data
  );
};
